export const DIALOG_WIDTH = '400px';
export const DIALOG_MAX_HEIGHT = '500px';

